import React from 'react';
import PropTypes from 'prop-types';
import { DragSource, DropTarget } from 'react-dnd';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import { itemSource, itemTarget } from '../../../helpers/dndSimple.helper';
import { Switch } from '@material-ui/core';

const styles = theme => ({
  listItem: {
    '&:hover': {
      background: theme.palette.grey[200],
    },
  },
  dragIcon: {
    float: 'left',
    marginRight: '4px',
    cursor: 'move',
    color: theme.palette.grey[500],
  },
  deleteIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[500],
    marginRight: '30px',

    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  switch: {
    marginRight: '25px',
    float: 'right',
  }
});

class GlobalRuleListItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
    this.handleChangeActiveRule = this.handleChangeActiveRule.bind(this);
    this.state = {
      active: false
    }
  }
  componentDidMount() {
    if (this.props.rule.active === undefined) {
      this.props.rule.active = true;
      this.handleChangeActiveRule(undefined, true);
    }
    this.setState({ active: this.props.rule.active });
  }
  handleDelete() {
    this.props.deleteRule(this.props.rule.id);
  }
  handleChangeActiveRule(event, checked) {
    this.setState({ active: checked });
    this.props.updateRuleActive(this.props.rule.id, checked);
  }
  render() {
    const {
      rule,
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
      isDragging,
      classes,
    } = this.props;
    return (
      connectDragPreview &&
      connectDragSource &&
      connectDropTarget &&
      connectDropTarget(connectDragPreview((
        <div>
          <ListItem
            style={{ opacity: (isDragging ? 0 : 1) }}
            className={classes.listItem}
          >
            {connectDragSource((
              <span>
                <Icon className={classes.dragIcon}>drag_indicator</Icon>
              </span>
            ))}
            <Icon
              onClick={() => { this.handleDelete(); }}
              className={classes.deleteIcon}
            >
              delete
            </Icon>
            <Typography>{rule.text}</Typography>
            <Switch
            onChange={this.handleChangeActiveRule}
            checked={this.state.active}
            className={classes.switch}
          />
          </ListItem>
          <Divider />
        </div>
      )))
    );
  }
}

GlobalRuleListItemComponent.propTypes = {
  rule: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    index: PropTypes.number,
  }).isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  /* eslint-disable react/forbid-prop-types,react/no-unused-prop-types */
  index: PropTypes.number.isRequired,
  moveRule: PropTypes.func.isRequired,
  dropRule: PropTypes.func.isRequired,
  deleteRule: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  updateRuleActive: PropTypes.func.isRequired,
  /* eslint-enable */
};

export default DropTarget('globalRule', itemTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))(DragSource('globalRule', itemSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
}))(withStyles(styles)(GlobalRuleListItemComponent)));
